export default "__VITE_ASSET__39080811__"